module.exports = __webpack_public_path__ + "img/mbanner_lens.6469c1bc.png";